import { render, staticRenderFns } from "./VueTablePaginationBootstrap.vue?vue&type=template&id=239077d1&"
import script from "./VueTablePaginationBootstrap.vue?vue&type=script&lang=js&"
export * from "./VueTablePaginationBootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('239077d1')) {
      api.createRecord('239077d1', component.options)
    } else {
      api.reload('239077d1', component.options)
    }
    module.hot.accept("./VueTablePaginationBootstrap.vue?vue&type=template&id=239077d1&", function () {
      api.rerender('239077d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/VueTablePaginationBootstrap.vue"
export default component.exports